<ng-content select="[description]"></ng-content>

<ui-form (handleSubmit)="submit()" class="mb-4" [attr.data-cy]="cy()?.form">
  @if (collapsibleLabel(); as label) {
    <p-accordion [multiple]="true" [value]="accordion()" (valueChange)="onAccordionChange($event)">
      <p-accordion-panel [value]="0" [attr.data-cy]="cy()?.panel">
        <p-accordion-header>{{ label }}</p-accordion-header>
        <p-accordion-content>
          <ng-container [ngTemplateOutlet]="fields"></ng-container>
          <ng-container [ngTemplateOutlet]="buttons"></ng-container>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  } @else {
    <ng-container [ngTemplateOutlet]="fields"></ng-container>
    <ng-container [ngTemplateOutlet]="buttons"></ng-container>
  }
</ui-form>

<ng-template #fields>
  <ng-content></ng-content>
</ng-template>

<ng-template #buttons>
  <ui-buttons>
    <button class="px-6" type="submit" pButton [attr.data-cy]="cy()?.search">
      <span pButtonLabel>{{ submitLabel() }}</span>
    </button>
    <button type="button" (click)="clear()" class="p-button-outlined px-6" pButton [attr.data-cy]="cy()?.clear">
      <span pButtonLabel>{{ clearLabel() }}</span>
    </button>
  </ui-buttons>
</ng-template>
